const InstantBookingGreen = ({
  width = "16",
  height = "16",
}: {
  width?: string;
  height?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M9.33526 2.66406C7.98193 2.66406 6.74859 3.17073 5.80859 3.9974H6.66859C7.40193 3.9974 8.00193 4.5974 8.00193 5.33073C8.00193 6.06406 7.40193 6.66406 6.66859 6.66406H6.00193C6.73526 6.66406 7.33526 7.26406 7.33526 7.9974C7.33526 8.73073 6.73526 9.33073 6.00193 9.33073H6.66859C7.40193 9.33073 8.00193 9.93073 8.00193 10.6641C8.00193 11.3974 7.40193 11.9974 6.66859 11.9974H5.80859C6.74859 12.8241 7.98186 13.3307 9.33526 13.3307C12.2819 13.3307 14.6686 10.9441 14.6686 7.9974C14.6686 5.05073 12.2819 2.66406 9.33526 2.66406ZM11.2619 8.96406C11.1486 9.1974 10.9153 9.33073 10.6686 9.33073C10.5686 9.33073 10.4686 9.31073 10.3686 9.2574L9.03526 8.59073C8.80859 8.4774 8.66859 8.25073 8.66859 7.9974V6.66406C8.66859 6.2974 8.96859 5.9974 9.33526 5.9974C9.70193 5.9974 10.0019 6.2974 10.0019 6.66406V7.58406L10.9686 8.07073C11.2953 8.23073 11.4286 8.63073 11.2619 8.96406Z"
      fill="#046C4E"
    />
    <path
      d="M3.33203 8.66406H4.0387H5.9987C6.36536 8.66406 6.66536 8.36406 6.66536 7.9974C6.66536 7.63073 6.36536 7.33073 5.9987 7.33073H4.0387H3.33203C2.96536 7.33073 2.66536 7.63073 2.66536 7.9974C2.66536 8.36406 2.96536 8.66406 3.33203 8.66406ZM4.40536 5.94406C4.48536 5.9774 4.57203 5.9974 4.66536 5.9974H6.66536C7.03203 5.9974 7.33203 5.6974 7.33203 5.33073C7.33203 4.96406 7.03203 4.66406 6.66536 4.66406H5.17203H4.66536C4.2987 4.66406 3.9987 4.96406 3.9987 5.33073C3.9987 5.60406 4.16536 5.84406 4.40536 5.94406ZM7.33203 10.6641C7.33203 10.2974 7.03203 9.9974 6.66536 9.9974H4.38536H1.9987C1.63203 9.9974 1.33203 10.2974 1.33203 10.6641C1.33203 11.0307 1.63203 11.3307 1.9987 11.3307H5.17203H6.66536C7.03203 11.3307 7.33203 11.0307 7.33203 10.6641Z"
      fill="#046C4E"
    />
  </svg>
);

export default InstantBookingGreen;
